import { RealTimeAction } from '@/_core/fluxstore/types';
import { Color, StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class McpSyncStoryMapColors extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'McpSyncStoryMapColors';

    public constructor(public colors: Color[]) {
        super(McpSyncStoryMapColors.ACTION_TYPE);
    }
}

const middleware = async (): Promise<boolean> => true;

const reducer = (state: StorymapState, action: McpSyncStoryMapColors): void => {
    state.colors = action.colors;
};

//@ts-ignore
registerMiddleware(McpSyncStoryMapColors.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(McpSyncStoryMapColors.ACTION_TYPE, reducer);
